import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  fetchApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import {
  MicrosoftCalendarApiClient,
  microsoftCalendarApiRef,
} from '@backstage-community/plugin-microsoft-calendar';

/**
 * An array of API factories used in the Backstage application to provide
 * implementations for specific API references.
 *
 * Each factory is responsible for creating an instance of an API implementation
 *
 */
export const apis: AnyApiFactory[] = [
  /**
   * Factory for the `ScmIntegrationsApi`, which provides SCM integrations
   * (e.g., GitHub, GitLab) configuration and utility methods.
   *
   * - **Dependencies**: `configApi`
   * - **API Reference**: `scmIntegrationsApiRef`
   */
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  /**
   * Factory for the `MicrosoftCalendarApiClient`, which allows interaction
   * with Microsoft Calendar APIs, such as fetching events.
   *
   * - **Dependencies**: `authApi`, `fetchApi`
   * - **API Reference**: `microsoftCalendarApiRef`
   */
  createApiFactory({
    api: microsoftCalendarApiRef,
    deps: { authApi: microsoftAuthApiRef, fetchApi: fetchApiRef },
    factory: deps => new MicrosoftCalendarApiClient(deps),
  }),
  /**
   * Default factory for SCM authentication, enabling access to various SCM
   * providers with a common interface.
   */
  ScmAuth.createDefaultApiFactory(),
];
